import { ADMINS, MODS } from '../config/accounts';


export const isPriviledgedUser = (uname = '') => MODS.includes(uname)
  || ADMINS.includes(uname);
